// extracted by mini-css-extract-plugin
export var label = "index-module--label--3KobX";